module.exports = __webpack_public_path__ + "static/img/beta_bg_04.4b433f6e.svg";